// extracted by mini-css-extract-plugin
export default {"container":"PrivacyPolicy_container__-4eXj","brand":"PrivacyPolicy_brand__dvd-X","box":"PrivacyPolicy_box__aMmM3"};